// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PDF journey layouts, mapped to the shared semantic design system. */
.rcti-designed {
  color: var(--text-primary);
  font-family: var(--font-family-primary);
}
.rcti-agreements.rcti-designed .rcti-agreements__content {
  max-width: 1440px;
  padding: var(--space-8) var(--space-6);
  gap: var(--space-6);
}
.rcti-designed h1,
.rcti-designed h2,
.rcti-designed h3,
.rcti-designed p {
  margin: 0;
}
.rcti-designed h1 {
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-h1);
}
.rcti-designed h2 {
  font-size: var(--font-size-h4);
  font-weight: var(--font-weight-medium);
}
.rcti-designed h3 {
  font-size: var(--font-size-body-md);
}
.rcti-designed p,
.rcti-designed small {
  color: var(--text-secondary);
}
.rcti-agreements__content a {
  color: var(--interactive-default);
  text-decoration: none;
}
.rcti-agreements__content a:hover {
  text-decoration: underline;
}
.rcti-design-heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-5);
}
.rcti-design-heading > div {
  display: grid;
  gap: var(--space-3);
}
.rcti-design-breadcrumb {
  font-size: var(--font-size-body-sm);
}
.rcti-design-back,
.rcti-agreements__content button.rcti-design-back {
  justify-self: start;
  padding: 0;
  min-height: 24px;
  background: transparent;
  color: var(--interactive-default);
}
.rcti-design-columns {
  display: grid;
  grid-template-columns: minmax(0, 1.6fr) minmax(280px, 1fr);
  align-items: start;
  gap: var(--space-6);
}
.rcti-design-stack,
.rcti-design-sidebar {
  display: grid;
  gap: var(--space-6);
  min-width: 0;
}
.rcti-designed .rcti-agreement-card {
  padding: var(--space-6);
  border-radius: var(--radius-lg);
  gap: var(--space-4);
}
.rcti-designed input:not([type="checkbox"]),
.rcti-designed select {
  min-height: 40px;
}
.rcti-designed label {
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-body-sm);
}
.rcti-designed label input,
.rcti-designed label select,
.rcti-designed label textarea {
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-body-sm);
}
.rcti-designed input[readonly] {
  background: var(--surface-secondary);
}
.rcti-designed textarea {
  resize: vertical;
}
.rcti-designed button,
.rcti-design-primary {
  height: 40px;
  min-height: 40px;
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium);
  line-height: normal;
  letter-spacing: 0;
}
.rcti-designed .rcti-design-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border-radius: var(--radius-md, 10px);
}
.rcti-designed button:hover:not(:disabled) {
  filter: brightness(0.96);
}
.rcti-agreements.rcti-designed
  :is(
    .rcti-design-metrics button,
    .rcti-design-tabs button,
    .rcti-design-register td button,
    .rcti-design-back,
    .rcti-button-secondary,
    .quotation-figma-dropdown-trigger,
    .quotation-figma-dropdown-option
  ):hover:not(:disabled) {
  background: var(--surface-secondary);
  filter: none;
}
.rcti-design-party-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5);
}
.rcti-design-party-grid > div {
  display: grid;
  gap: var(--space-3);
  align-content: start;
}
.rcti-design-party-grid small {
  font-size: var(--font-size-caption-md);
}
.rcti-design-notice {
  display: grid;
  gap: var(--space-3);
  padding: var(--space-4);
  background: var(--surface-secondary);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  font-size: var(--font-size-body-sm);
}
.rcti-design-notice strong {
  color: var(--text-primary);
}
.rcti-design-checks {
  display: grid;
  gap: var(--space-4);
  list-style: none;
  padding: 0;
  margin: 0;
}
.rcti-design-checks li::before {
  content: "✓";
  color: var(--success-text);
  margin-right: var(--space-3);
}
.rcti-design-terms {
  white-space: pre-line;
}
.rcti-designed hr {
  border: 0;
  border-top: 1px solid var(--border-subtle);
  width: 100%;
}
.rcti-design-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space-6);
}
.rcti-designed .rcti-design-metrics button {
  background: var(--surface-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
  text-align: left;
}
.rcti-design-metrics strong {
  font: var(--font-weight-medium) var(--font-size-h2) / 1.3
    var(--font-family-mono);
}
.rcti-design-metrics span {
  color: var(--text-secondary);
}
.rcti-design-tabs {
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid var(--border-default);
  gap: var(--space-3);
}
.rcti-designed .rcti-design-tabs button {
  background: transparent;
  color: var(--text-secondary);
  border-radius: 0;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
}
.rcti-designed .rcti-design-tabs button.is-active {
  color: var(--interactive-default);
  border-color: var(--interactive-default);
}
.rcti-design-filter {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}
.rcti-design-filter label {
  width: min(460px, 100%);
}
.rcti-design-filter > span {
  margin-left: auto;
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-design-register {
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  background: var(--surface-primary);
  overflow: hidden;
}
.rcti-design-register > h2 {
  padding: var(--space-5);
}
.rcti-design-table-scroll {
  overflow-x: auto;
}
.rcti-design-register table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
  font-size: var(--font-size-body-sm);
}
.rcti-design-register th {
  text-align: left;
  color: var(--text-secondary);
  background: var(--surface-secondary);
  font-weight: var(--font-weight-medium);
  padding: var(--space-4);
  white-space: nowrap;
}
.rcti-design-register td {
  padding: var(--space-5) var(--space-4);
  border-top: 1px solid var(--border-default);
  vertical-align: middle;
  max-width: 260px;
  overflow-wrap: anywhere;
}
.rcti-design-register td small {
  display: block;
  margin-top: var(--space-2);
  font-size: var(--font-size-caption-md);
}
.rcti-designed .rcti-design-register td button {
  padding: 0;
  background: transparent;
  color: var(--interactive-default);
  text-align: left;
}
.rcti-design-empty {
  padding: var(--space-8);
  text-align: center;
  display: grid;
  justify-items: center;
  gap: var(--space-4);
}
.rcti-design-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
  border-top: 1px solid var(--border-default);
  padding-top: var(--space-5);
}
.rcti-design-email-cta {
  justify-self: start;
  padding: var(--space-3) var(--space-4);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border-radius: var(--radius-md);
}
.rcti-design-timeline {
  padding: 0 0 0 var(--space-4);
  display: grid;
  gap: var(--space-5);
}
.rcti-design-timeline li {
  padding-left: var(--space-2);
}
.rcti-design-timeline small {
  display: block;
  margin-top: var(--space-2);
}
.rcti-journey {
  list-style: none;
  padding: var(--space-4) 0;
  margin: 0 0 var(--space-6);
  display: flex;
  gap: var(--space-5);
}
.rcti-journey li {
  flex: 1 1;
  display: flex;
  align-items: center;
  position: relative;
  min-width: 0;
}
.rcti-journey-step {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  width: auto;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  font: inherit;
}
.rcti-journey-step:disabled {
  cursor: default;
}
.rcti-journey li.is-clickable .rcti-journey-step {
  cursor: pointer;
}
.rcti-journey li.is-clickable .rcti-journey-step:hover strong {
  color: var(--interactive-default);
}
.rcti-journey-step:focus-visible {
  outline: 2px solid var(--focus-outline, var(--interactive-default));
  outline-offset: 3px;
  border-radius: var(--radius-sm);
}
.rcti-journey li:not(:last-child)::after {
  content: "";
  height: 1px;
  flex: 1 1;
  margin: 0 var(--space-2);
  background: var(--border-default);
}
.rcti-journey-step > span {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  border-radius: var(--radius-pill);
  background: var(--surface-tertiary);
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.rcti-journey li.is-current > .rcti-journey-step > span,
.rcti-journey li.is-complete > .rcti-journey-step > span {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.rcti-journey-step strong {
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.rcti-journey-step small {
  display: block;
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
  margin-top: var(--space-1);
}
.rcti-designed .rcti-consent {
  font-weight: var(--font-weight-regular);
  line-height: 1.6;
}
.rcti-designed .rcti-consent input {
  accent-color: var(--interactive-default);
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  margin-top: 3px;
}
.rcti-designed .rcti-agreement-document {
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  padding: var(--space-8);
}
.rcti-designed .rcti-agreement-document__header {
  display: grid;
  gap: var(--space-3);
}
.rcti-designed .rcti-agreement-document__header h2 {
  font-size: var(--font-size-h2);
  line-height: 1.3;
  margin: var(--space-3) 0;
}
.rcti-designed .rcti-agreement-document__header > div > .rcti-document-eyebrow {
  color: var(--interactive-default);
  text-transform: none;
}
.rcti-designed .rcti-agreement-document__metadata {
  display: grid;
  background: var(--surface-secondary);
  padding: var(--space-4);
  gap: var(--space-3);
}
.rcti-designed .rcti-agreement-document__section h3 > span {
  display: none;
}
.rcti-designed .rcti-agreement-document__section h3 {
  margin-bottom: var(--space-3);
}
.rcti-public-topbar {
  padding: var(--space-5) var(--space-8);
  display: flex;
  justify-content: space-between;
  gap: var(--space-4);
  background: var(--surface-primary);
  border-bottom: 1px solid var(--border-subtle);
}
.rcti-public-topbar strong {
  color: var(--interactive-default);
}
.rcti-public-topbar span {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-designed .rcti-public-workspace {
  border: 0;
  background: transparent;
  padding: 0;
  grid-template-columns: minmax(0, 1.5fr) minmax(300px, 1fr);
  display: grid;
  gap: var(--space-6);
  align-items: start;
}
.rcti-public-workspace > form,
.rcti-public-workspace > .rcti-public-controls {
  grid-column: 2;
  grid-row: 1;
  padding: var(--space-6);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  display: grid;
  gap: var(--space-5);
}
.rcti-public-workspace > .rcti-agreement-document {
  grid-column: 1;
  grid-row: 1 / span 6;
}
.rcti-public-workspace > button {
  grid-column: 2;
}
@media (max-width: 1000px) {
  .rcti-design-columns {
    grid-template-columns: minmax(0, 1.4fr) minmax(260px, 1fr);
  }
  .rcti-designed .rcti-agreement-document {
    padding: var(--space-5);
  }
}
@media (max-width: 760px) {
  .rcti-agreements.rcti-designed .rcti-agreements__content {
    padding: var(--space-5) var(--space-4);
  }
  .rcti-design-columns,
  .rcti-designed .rcti-public-workspace {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-public-workspace > .rcti-agreement-document,
  .rcti-public-workspace > form,
  .rcti-public-workspace > button,
  .rcti-public-workspace > .rcti-public-controls {
    grid-column: 1;
    grid-row: auto;
  }
  .rcti-design-metrics {
    gap: var(--space-3);
  }
  .rcti-designed .rcti-design-metrics .rcti-agreement-card {
    padding: var(--space-4);
  }
  .rcti-design-metrics span {
    font-size: var(--font-size-caption-md);
  }
  .rcti-design-heading {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .rcti-design-heading h1 {
    font-size: var(--font-size-h2);
  }
  .rcti-design-filter {
    flex-wrap: wrap;
  }
  .rcti-journey {
    gap: var(--space-3);
  }
  .rcti-journey li {
    flex: 1 1;
  }
  .rcti-journey li::after {
    display: none;
  }
  .rcti-journey-step {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-2);
  }
  .rcti-journey-step strong {
    font-size: var(--font-size-caption-md);
  }
  .rcti-journey-step small {
    display: none;
  }
  .rcti-public-topbar {
    padding: var(--space-4);
    flex-wrap: wrap;
  }
  .rcti-design-party-grid {
    grid-template-columns: 1fr;
  }
  .rcti-design-footer {
    position: sticky;
    bottom: 0;
    background: var(--bg-primary);
    padding-bottom: var(--space-4);
    z-index: 4;
  }
}
@media print {
  .rcti-public-topbar,
  .rcti-journey,
  .rcti-design-footer,
  .rcti-public-workspace > form {
    display: none !important;
  }
  .rcti-designed .rcti-public-workspace {
    display: block;
  }
}
/* Prepare, issue and detail use the same page rhythm as the PDF journeys. */
.rcti-list-page,
.rcti-editor-shell .invoice-editor-page,
.rcti-detail-page {
  max-width: 1440px;
  margin-inline: auto;
  padding: var(--space-8) var(--space-6);
}
.rcti-list-heading h1,
.rcti-editor-shell .invoice-editor-header h1 {
  font-size: var(--font-size-h1);
  line-height: var(--line-height-h1);
  font-weight: var(--font-weight-semibold);
}
.rcti-list-heading .rcti-header-actions {
  margin-left: auto;
}
.rcti-header-actions a {
  text-decoration: none;
}
.rcti-list-heading .rcti-design-breadcrumb {
  margin-bottom: var(--space-3);
}
.rcti-financial-card {
  border-radius: var(--radius-lg);
  padding: var(--space-6);
}
.rcti-financial-card strong {
  font-family: var(--font-family-mono);
  font-weight: var(--font-weight-medium);
}
.rcti-list-page .rcti-filters {
  background: transparent;
  border: 0;
  padding: 0;
}
.rcti-list-page .rcti-list-filter-row {
  padding: var(--space-4) 0;
}
.rcti-list-page .rcti-date-hint {
  margin-top: 0;
}
.rcti-editor-shell .invoice-editor-grid {
  grid-template-columns: minmax(0, 1fr);
}
.rcti-editor-shell .invoice-editor-column {
  gap: var(--space-6);
}
.rcti-editor-shell .invoice-editor-aside {
  position: static;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-6);
  align-items: start;
}
.rcti-editor-shell .invoice-flow-card,
.rcti-detail-page .invoice-flow-card {
  padding: var(--space-6);
  border-radius: var(--radius-lg);
}
.rcti-editor-shell .invoice-total-card {
  display: block;
}
.rcti-editor-shell .invoice-editor-aside > .invoice-document-actions {
  grid-column: 1 / -1;
}
.rcti-editor-shell .invoice-item-table-head {
  border-radius: var(--radius-md) var(--radius-md) 0 0;
}
.rcti-editor-shell .invoice-editor-intro {
  font-size: var(--font-size-body-sm);
  color: var(--text-secondary);
}
.rcti-detail-document .rcti-paper-parties {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-bottom: 1px solid var(--border-subtle);
  padding-bottom: var(--space-5);
}
.rcti-detail-document .rcti-paper-heading {
  min-height: 24px;
  margin-bottom: var(--space-4);
}
.rcti-detail-document .rcti-paper-business .rcti-type-emphasis {
  color: var(--interactive-default);
  font-size: var(--font-size-body-sm);
}
.rcti-detail-document .rcti-paper-identity h2 {
  font-size: var(--font-size-h2);
  font-weight: var(--font-weight-semibold);
}
.rcti-detail-document .rcti-paper-identity > span {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-body-sm);
}
.rcti-detail-document .rcti-detail-meta {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.rcti-detail-document .rcti-document-table-scroll {
  border: 0;
  border-radius: 0;
}
.rcti-detail-document .rcti-document-table th {
  background: var(--surface-secondary);
}
.rcti-detail-document .rcti-detail-summary .grand {
  background: transparent;
  padding-inline: 0;
  border-top: 1px solid var(--border-default);
  border-radius: 0;
}
.rcti-detail-page .rcti-detail-context {
  background: var(--success-soft);
  border-color: var(--success-border);
}
.rcti-detail-page .rcti-detail-context .rcti-type-emphasis {
  color: var(--success-text);
}
.rcti-review-workspace.rcti-communication-backdrop {
  padding: 0;
  background: var(--bg-primary);
  align-items: stretch;
  z-index: 1300;
}
.rcti-review-workspace .rcti-communication-dialog {
  max-width: none;
  width: 100%;
  max-height: 100dvh;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  background: var(--bg-primary);
  padding: var(--space-6) max(var(--space-6), calc((100vw - 1300px) / 2));
  overflow-y: auto;
}
.rcti-review-workspace .rcti-communication-header {
  padding: 0 0 var(--space-5);
  border: 0;
  background: transparent;
}
.rcti-review-workspace .rcti-communication-header h2 {
  font-size: var(--font-size-h1);
}
.rcti-review-workspace .rcti-review-columns,
.rcti-review-eligibility {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(300px, 1fr);
  align-items: start;
  gap: var(--space-6);
}
.rcti-review-workspace .rcti-review-columns > form,
.rcti-review-workspace .rcti-agreement-card {
  display: grid;
  gap: var(--space-5);
  min-width: 0;
  padding: var(--space-6);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
}
.rcti-review-document {
  min-width: 0;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background: var(--surface-primary);
}
.rcti-review-document-bar {
  padding: var(--space-4);
  background: var(--surface-secondary);
  display: flex;
  justify-content: space-between;
  gap: var(--space-3);
  font-size: var(--font-size-body-sm);
}
.rcti-review-workspace .rcti-detail-document {
  padding: var(--space-6);
  border: 0;
  border-radius: 0;
  margin: 0;
}
.rcti-review-workspace .rcti-detail-document .rcti-document-table {
  min-width: 580px;
}
.rcti-review-workspace .rcti-communication-field {
  margin: 0;
}
.rcti-review-workspace .rcti-communication-context {
  margin: 0;
}
.rcti-review-workspace .rcti-communication-actions {
  padding: var(--space-4) 0 0;
  margin: 0;
  background: transparent;
}
.rcti-review-workspace .rcti-communication-actions .primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
}
.rcti-review-issue-info {
  display: grid;
  gap: var(--space-4);
  border-top: 1px solid var(--border-default);
  padding-top: var(--space-5);
}
.rcti-review-issue-info p,
.rcti-review-issue-info label {
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-review-checks {
  margin: 0;
  padding: 0;
  list-style: none;
}
.rcti-review-checks li {
  padding: var(--space-5) 0;
  border-bottom: 1px solid var(--border-subtle);
}
.rcti-review-checks li:last-child {
  border: 0;
}
.rcti-review-checks strong {
  font-size: var(--font-size-body-md);
}
.rcti-review-checks p {
  margin-top: var(--space-3);
  font-size: var(--font-size-body-sm);
}
.rcti-review-workspace button {
  cursor: pointer;
}
.rcti-review-workspace .rcti-communication-success {
  max-width: 680px;
  margin: var(--space-8) auto;
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-lg);
}
@media (max-width: 760px) {
  .rcti-list-page,
  .rcti-editor-shell .invoice-editor-page,
  .rcti-detail-page {
    padding: var(--space-5) var(--space-4);
  }
  .rcti-editor-shell .invoice-editor-aside,
  .rcti-review-workspace .rcti-review-columns,
  .rcti-review-eligibility {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-review-workspace .rcti-communication-dialog {
    padding: var(--space-5) var(--space-4);
  }
  .rcti-review-workspace .rcti-communication-header h2 {
    font-size: var(--font-size-h2);
  }
  .rcti-detail-document .rcti-paper-parties {
    grid-template-columns: 1fr;
  }
  .rcti-list-heading .rcti-header-actions {
    margin-left: 0;
  }
}
.rcti-agreements.rcti-designed .rcti-design-metrics > button {
  width: 100%;
  min-height: 154px;
  align-content: start;
}
.rcti-designed .rcti-design-metrics > button > span {
  font-size: var(--font-size-body-md);
  font-weight: var(--font-weight-medium);
}
.rcti-designed .rcti-design-register td:first-child > button {
  font-family: var(--font-family-mono);
  white-space: nowrap;
}
.rcti-designed .rcti-design-register .rcti-agreement-badge {
  white-space: nowrap;
}
.rcti-agreements__content .rcti-design-heading > button,
.rcti-agreements__content .rcti-design-footer > button:last-child {
  color: var(--on-interactive-primary);
}
.rcti-editor-shell .invoice-editor-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: start;
}
.rcti-editor-shell .invoice-editor-header > small {
  grid-column: 1 / -1;
}
.rcti-editor-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-4);
  border-top: 1px solid var(--border-default);
  margin-top: var(--space-6);
  padding-top: var(--space-5);
}
.rcti-editor-footer > div {
  display: flex;
  gap: var(--space-3);
}
.rcti-editor-footer button {
  display: inline-flex;
  height: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md, 10px);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: normal 500 13px/normal var(--font-family-primary, "Lexend", sans-serif);
  cursor: pointer;
}
.rcti-editor-footer button.primary {
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border-color: var(--interactive-default);
}
.rcti-editor-footer button:disabled {
  opacity: 0.5;
  cursor: default;
}
.rcti-editor-agreement-strip {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-5);
  margin: var(--space-4) 0;
  padding: var(--space-4);
  border-radius: var(--radius-md);
  background: var(--surface-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-editor-agreement-strip > div {
  display: grid;
  gap: var(--space-2);
  justify-items: start;
}
.rcti-editor-agreement-strip a {
  color: var(--interactive-default);
}
@media (max-width: 760px) {
  .rcti-editor-shell .invoice-editor-header {
    grid-template-columns: 1fr;
  }
  .rcti-editor-footer {
    flex-wrap: wrap;
  }
  .rcti-editor-footer > div {
    flex-wrap: wrap;
  }
  .rcti-editor-agreement-strip {
    grid-template-columns: 1fr;
  }
}
.rcti-editor-shell .invoice-editor-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  align-items: start;
  gap: var(--space-6);
}
.rcti-editor-shell .invoice-editor-column {
  display: flex;
  min-width: 0;
}
.rcti-editor-shell .invoice-editor-aside {
  grid-column: 2;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  position: sticky;
  top: 88px;
  max-height: calc(100vh - 112px);
  overflow-y: auto;
  min-width: 0;
}
.rcti-editor-shell .invoice-editor-aside > * {
  width: 100%;
  min-width: 0;
  flex-shrink: 0;
}
.rcti-editor-shell .invoice-summary-card {
  order: 0;
}
.rcti-editor-shell .rcti-editor-notes .invoice-notes-fields {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.rcti-editor-shell .rcti-editor-notes textarea {
  min-height: 88px;
}
.rcti-editor-shell .rcti-editor-notes h3 {
  font-size: var(--font-size-body-sm);
  margin: var(--space-5) 0 var(--space-3);
}
.rcti-editor-settlement h2 {
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
  margin: 0 0 var(--space-5);
}
@media (min-width: 701px) {
  .rcti-editor-shell .invoice-date-fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  .rcti-editor-shell .invoice-item-heading,
  .rcti-editor-shell .invoice-edit-item {
    grid-template-columns: minmax(0, 1fr) 48px 96px 84px 104px 32px;
  }
  .rcti-editor-shell .invoice-edit-item .discount-type {
    width: 100%;
    max-width: 148px;
  }
}
@media (max-width: 1279px) {
  .rcti-editor-shell .invoice-editor-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .rcti-editor-shell .invoice-editor-aside {
    grid-column: 1;
    grid-row: auto;
    position: static;
    max-height: none;
    overflow-y: visible;
  }
  .rcti-editor-shell .rcti-editor-notes .invoice-notes-fields {
    grid-template-columns: 1fr;
  }
}
/* Override the shared launcher's !important mobile display: AppHeader already
   supplies this menu, and the duplicate must not cover footer actions. */
.rcti-designed .dashboard-sidebar-launcher,
.rcti-editor-shell .dashboard-sidebar-launcher,
.rcti-detail-shell .dashboard-sidebar-launcher,
.rcti-flow-shell .dashboard-sidebar-launcher {
  display: none !important;
}
/* Shared themed dropdowns must override agreement-wide button styling. */
.rcti-agreements__content .quotation-figma-dropdown { width: 100%; min-width: 0; }
.rcti-agreements__content .quotation-figma-dropdown-trigger,
.rcti-flow-shell .rcti-filter-select .quotation-figma-dropdown-trigger,
.rcti-payment-dialog .quotation-figma-dropdown-trigger {
  display: flex; align-items: center; justify-content: space-between;
  width: 100%; min-height: 40px; height: 40px; padding: 0 var(--space-3);
  border: 1px solid var(--border-default); border-radius: var(--radius-md);
  background: var(--surface-primary); color: var(--text-primary);
  font: inherit; font-size: var(--font-size-body-sm); text-align: left;
}
.rcti-agreements__content .quotation-figma-dropdown-trigger:hover:not(:disabled) { background: var(--surface-secondary); }
.rcti-agreements__content .quotation-figma-dropdown-option {
  width: 100%; min-height: 36px; padding: var(--space-2) var(--space-3);
  border: 0; border-radius: var(--radius-sm); background: transparent;
  color: var(--text-primary); font-size: var(--font-size-body-sm); text-align: left;
}
.rcti-agreements__content .quotation-figma-dropdown-option:hover:not(:disabled),
.rcti-agreements__content .quotation-figma-dropdown-option.is-selected {
  background: var(--interactive-soft); color: var(--interactive-default);
}
.rcti-flow-shell .rcti-filter-select { padding: 0; border: 0; background: transparent; }
.rcti-filter-select .quotation-figma-dropdown { width: 100%; min-width: 180px; }
.rcti-flow-shell .rcti-filter-select { flex: 0 1 200px; width: 200px; min-width: 0; }
.rcti-flow-shell .rcti-due-select { flex-basis: 240px; width: 240px; }
.rcti-filter-select .quotation-figma-dropdown { min-width: 0; }
.rcti-filter-select .quotation-figma-dropdown svg { position: static; right: auto; pointer-events: none; }
.rcti-agreements__content .quotation-figma-dropdown-trigger > svg,
.rcti-filter-select .quotation-figma-dropdown-trigger > svg,
.rcti-payment-dialog .quotation-figma-dropdown-trigger > svg {
  display: block; position: static; flex: 0 0 20px; width: 20px; height: 20px;
  overflow: visible; color: var(--text-secondary);
}
@media (max-width: 760px) {
 .rcti-flow-shell .rcti-filter-select, .rcti-flow-shell .rcti-due-select { flex: 1 1 160px; width: auto; }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/rctiDesign.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,mBAAmB;AACrB;AACA;;;;EAIE,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,kCAAkC;AACpC;AACA;EACE,8BAA8B;EAC9B,sCAAsC;AACxC;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,4BAA4B;AAC9B;AACA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;;EAEE,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,0DAA0D;EAC1D,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mCAAmC;AACrC;AACA;;;EAGE,uCAAuC;EACvC,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,oCAAoC;EACpC,qCAAqC;AACvC;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;;;;;;EAUE,oCAAoC;EACpC,YAAY;AACd;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,YAAY;EACZ,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE;2BACyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,iCAAiC;EACjC,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,sCAAsC;EACtC,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,2CAA2C;EAC3C,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,sCAAsC;AACxC;AACA;EACE,UAAU;EACV,uBAAuB;EACvB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,sCAAsC;EACtC,oCAAoC;EACpC,+BAA+B;AACjC;AACA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mEAAmE;EACnE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,WAAW;EACX,SAAO;EACP,wBAAwB;EACxB,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iCAAiC;EACjC,mCAAmC;EACnC,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;;EAEE,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,4BAA4B;EAC5B,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,oCAAoC;EACpC,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,6CAA6C;AAC/C;AACA;EACE,iCAAiC;AACnC;AACA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,0DAA0D;EAC1D,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,WAAW;EACX,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,0DAA0D;EAC5D;EACA;IACE,uBAAuB;EACzB;AACF;AACA;EACE;IACE,sCAAsC;EACxC;EACA;;IAEE,qCAAqC;EACvC;EACA;;;;IAIE,cAAc;IACd,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,8BAA8B;EAChC;EACA;IACE,eAAe;EACjB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,SAAO;EACT;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,sCAAsC;EACxC;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;IAChB,SAAS;IACT,6BAA6B;IAC7B,8BAA8B;IAC9B,UAAU;EACZ;AACF;AACA;EACE;;;;IAIE,wBAAwB;EAC1B;EACA;IACE,cAAc;EAChB;AACF;AACA,4EAA4E;AAC5E;;;EAGE,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;AACA;;EAEE,8BAA8B;EAC9B,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,uBAAuB;EACvB,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;EACE,gDAAgD;EAChD,6CAA6C;EAC7C,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;AACA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,gDAAgD;AAClD;AACA;EACE,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,uEAAuE;EACvE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,aAAa;EACb,2DAA2D;EAC3D,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;;EAEE,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6CAA6C;AAC/C;AACA;EACE,SAAS;AACX;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE;;;IAGE,sCAAsC;EACxC;EACA;;;IAGE,qCAAqC;EACvC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,8BAA8B;EAChC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,cAAc;EAChB;AACF;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,6EAA6E;EAC7E,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,+BAA+B;EAC/B,oCAAoC;EACpC,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,iCAAiC;AACnC;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,QAAQ;AACV;AACA;EACE,gDAAgD;AAClD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;AACA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,0BAA0B;AAC5B;AACA;EACE;IACE,gDAAgD;EAClD;EACA;;IAEE,+DAA+D;EACjE;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;AACA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;yEACyE;AACzE;;;;EAIE,wBAAwB;AAC1B;AACA,yEAAyE;AACzE,sDAAsD,WAAW,EAAE,YAAY,EAAE;AACjF;;;EAGE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,WAAW,EAAE,gBAAgB,EAAE,YAAY,EAAE,yBAAyB;EACtE,uCAAuC,EAAE,+BAA+B;EACxE,kCAAkC,EAAE,0BAA0B;EAC9D,aAAa,EAAE,mCAAmC,EAAE,gBAAgB;AACtE;AACA,mFAAmF,oCAAoC,EAAE;AACzH;EACE,WAAW,EAAE,gBAAgB,EAAE,sCAAsC;EACrE,SAAS,EAAE,+BAA+B,EAAE,uBAAuB;EACnE,0BAA0B,EAAE,mCAAmC,EAAE,gBAAgB;AACnF;AACA;;EAEE,mCAAmC,EAAE,iCAAiC;AACxE;AACA,uCAAuC,UAAU,EAAE,SAAS,EAAE,uBAAuB,EAAE;AACvF,gDAAgD,WAAW,EAAE,gBAAgB,EAAE;AAC/E,uCAAuC,eAAe,EAAE,YAAY,EAAE,YAAY,EAAE;AACpF,oCAAoC,iBAAiB,EAAE,YAAY,EAAE;AACrE,gDAAgD,YAAY,EAAE;AAC9D,oDAAoD,gBAAgB,EAAE,WAAW,EAAE,oBAAoB,EAAE;AACzG;;;EAGE,cAAc,EAAE,gBAAgB,EAAE,cAAc,EAAE,WAAW,EAAE,YAAY;EAC3E,iBAAiB,EAAE,4BAA4B;AACjD;AACA;CACC,0EAA0E,eAAe,EAAE,WAAW,EAAE;AACzG","sourcesContent":["/* PDF journey layouts, mapped to the shared semantic design system. */\n.rcti-designed {\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n}\n.rcti-agreements.rcti-designed .rcti-agreements__content {\n  max-width: 1440px;\n  padding: var(--space-8) var(--space-6);\n  gap: var(--space-6);\n}\n.rcti-designed h1,\n.rcti-designed h2,\n.rcti-designed h3,\n.rcti-designed p {\n  margin: 0;\n}\n.rcti-designed h1 {\n  font-size: var(--font-size-h1);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-h1);\n}\n.rcti-designed h2 {\n  font-size: var(--font-size-h4);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-designed h3 {\n  font-size: var(--font-size-body-md);\n}\n.rcti-designed p,\n.rcti-designed small {\n  color: var(--text-secondary);\n}\n.rcti-agreements__content a {\n  color: var(--interactive-default);\n  text-decoration: none;\n}\n.rcti-agreements__content a:hover {\n  text-decoration: underline;\n}\n.rcti-design-heading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-5);\n}\n.rcti-design-heading > div {\n  display: grid;\n  gap: var(--space-3);\n}\n.rcti-design-breadcrumb {\n  font-size: var(--font-size-body-sm);\n}\n.rcti-design-back,\n.rcti-agreements__content button.rcti-design-back {\n  justify-self: start;\n  padding: 0;\n  min-height: 24px;\n  background: transparent;\n  color: var(--interactive-default);\n}\n.rcti-design-columns {\n  display: grid;\n  grid-template-columns: minmax(0, 1.6fr) minmax(280px, 1fr);\n  align-items: start;\n  gap: var(--space-6);\n}\n.rcti-design-stack,\n.rcti-design-sidebar {\n  display: grid;\n  gap: var(--space-6);\n  min-width: 0;\n}\n.rcti-designed .rcti-agreement-card {\n  padding: var(--space-6);\n  border-radius: var(--radius-lg);\n  gap: var(--space-4);\n}\n.rcti-designed input:not([type=\"checkbox\"]),\n.rcti-designed select {\n  min-height: 40px;\n}\n.rcti-designed label {\n  font-weight: var(--font-weight-medium);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-designed label input,\n.rcti-designed label select,\n.rcti-designed label textarea {\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-designed input[readonly] {\n  background: var(--surface-secondary);\n}\n.rcti-designed textarea {\n  resize: vertical;\n}\n.rcti-designed button,\n.rcti-design-primary {\n  height: 40px;\n  min-height: 40px;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium);\n  line-height: normal;\n  letter-spacing: 0;\n}\n.rcti-designed .rcti-design-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border-radius: var(--radius-md, 10px);\n}\n.rcti-designed button:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n.rcti-agreements.rcti-designed\n  :is(\n    .rcti-design-metrics button,\n    .rcti-design-tabs button,\n    .rcti-design-register td button,\n    .rcti-design-back,\n    .rcti-button-secondary,\n    .quotation-figma-dropdown-trigger,\n    .quotation-figma-dropdown-option\n  ):hover:not(:disabled) {\n  background: var(--surface-secondary);\n  filter: none;\n}\n.rcti-design-party-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-5);\n}\n.rcti-design-party-grid > div {\n  display: grid;\n  gap: var(--space-3);\n  align-content: start;\n}\n.rcti-design-party-grid small {\n  font-size: var(--font-size-caption-md);\n}\n.rcti-design-notice {\n  display: grid;\n  gap: var(--space-3);\n  padding: var(--space-4);\n  background: var(--surface-secondary);\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-design-notice strong {\n  color: var(--text-primary);\n}\n.rcti-design-checks {\n  display: grid;\n  gap: var(--space-4);\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.rcti-design-checks li::before {\n  content: \"✓\";\n  color: var(--success-text);\n  margin-right: var(--space-3);\n}\n.rcti-design-terms {\n  white-space: pre-line;\n}\n.rcti-designed hr {\n  border: 0;\n  border-top: 1px solid var(--border-subtle);\n  width: 100%;\n}\n.rcti-design-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: var(--space-6);\n}\n.rcti-designed .rcti-design-metrics button {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-default);\n  text-align: left;\n}\n.rcti-design-metrics strong {\n  font: var(--font-weight-medium) var(--font-size-h2) / 1.3\n    var(--font-family-mono);\n}\n.rcti-design-metrics span {\n  color: var(--text-secondary);\n}\n.rcti-design-tabs {\n  display: flex;\n  overflow-x: auto;\n  border-bottom: 1px solid var(--border-default);\n  gap: var(--space-3);\n}\n.rcti-designed .rcti-design-tabs button {\n  background: transparent;\n  color: var(--text-secondary);\n  border-radius: 0;\n  white-space: nowrap;\n  border-bottom: 2px solid transparent;\n}\n.rcti-designed .rcti-design-tabs button.is-active {\n  color: var(--interactive-default);\n  border-color: var(--interactive-default);\n}\n.rcti-design-filter {\n  display: flex;\n  align-items: center;\n  gap: var(--space-4);\n}\n.rcti-design-filter label {\n  width: min(460px, 100%);\n}\n.rcti-design-filter > span {\n  margin-left: auto;\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-design-register {\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  background: var(--surface-primary);\n  overflow: hidden;\n}\n.rcti-design-register > h2 {\n  padding: var(--space-5);\n}\n.rcti-design-table-scroll {\n  overflow-x: auto;\n}\n.rcti-design-register table {\n  width: 100%;\n  min-width: 800px;\n  border-collapse: collapse;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-design-register th {\n  text-align: left;\n  color: var(--text-secondary);\n  background: var(--surface-secondary);\n  font-weight: var(--font-weight-medium);\n  padding: var(--space-4);\n  white-space: nowrap;\n}\n.rcti-design-register td {\n  padding: var(--space-5) var(--space-4);\n  border-top: 1px solid var(--border-default);\n  vertical-align: middle;\n  max-width: 260px;\n  overflow-wrap: anywhere;\n}\n.rcti-design-register td small {\n  display: block;\n  margin-top: var(--space-2);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-designed .rcti-design-register td button {\n  padding: 0;\n  background: transparent;\n  color: var(--interactive-default);\n  text-align: left;\n}\n.rcti-design-empty {\n  padding: var(--space-8);\n  text-align: center;\n  display: grid;\n  justify-items: center;\n  gap: var(--space-4);\n}\n.rcti-design-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n  border-top: 1px solid var(--border-default);\n  padding-top: var(--space-5);\n}\n.rcti-design-email-cta {\n  justify-self: start;\n  padding: var(--space-3) var(--space-4);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border-radius: var(--radius-md);\n}\n.rcti-design-timeline {\n  padding: 0 0 0 var(--space-4);\n  display: grid;\n  gap: var(--space-5);\n}\n.rcti-design-timeline li {\n  padding-left: var(--space-2);\n}\n.rcti-design-timeline small {\n  display: block;\n  margin-top: var(--space-2);\n}\n.rcti-journey {\n  list-style: none;\n  padding: var(--space-4) 0;\n  margin: 0 0 var(--space-6);\n  display: flex;\n  gap: var(--space-5);\n}\n.rcti-journey li {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  position: relative;\n  min-width: 0;\n}\n.rcti-journey-step {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  width: auto;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  font: inherit;\n}\n.rcti-journey-step:disabled {\n  cursor: default;\n}\n.rcti-journey li.is-clickable .rcti-journey-step {\n  cursor: pointer;\n}\n.rcti-journey li.is-clickable .rcti-journey-step:hover strong {\n  color: var(--interactive-default);\n}\n.rcti-journey-step:focus-visible {\n  outline: 2px solid var(--focus-outline, var(--interactive-default));\n  outline-offset: 3px;\n  border-radius: var(--radius-sm);\n}\n.rcti-journey li:not(:last-child)::after {\n  content: \"\";\n  height: 1px;\n  flex: 1;\n  margin: 0 var(--space-2);\n  background: var(--border-default);\n}\n.rcti-journey-step > span {\n  display: grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  flex: 0 0 28px;\n  border-radius: var(--radius-pill);\n  background: var(--surface-tertiary);\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-journey li.is-current > .rcti-journey-step > span,\n.rcti-journey li.is-complete > .rcti-journey-step > span {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.rcti-journey-step strong {\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-journey-step small {\n  display: block;\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n  margin-top: var(--space-1);\n}\n.rcti-designed .rcti-consent {\n  font-weight: var(--font-weight-regular);\n  line-height: 1.6;\n}\n.rcti-designed .rcti-consent input {\n  accent-color: var(--interactive-default);\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  margin-top: 3px;\n}\n.rcti-designed .rcti-agreement-document {\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  padding: var(--space-8);\n}\n.rcti-designed .rcti-agreement-document__header {\n  display: grid;\n  gap: var(--space-3);\n}\n.rcti-designed .rcti-agreement-document__header h2 {\n  font-size: var(--font-size-h2);\n  line-height: 1.3;\n  margin: var(--space-3) 0;\n}\n.rcti-designed .rcti-agreement-document__header > div > .rcti-document-eyebrow {\n  color: var(--interactive-default);\n  text-transform: none;\n}\n.rcti-designed .rcti-agreement-document__metadata {\n  display: grid;\n  background: var(--surface-secondary);\n  padding: var(--space-4);\n  gap: var(--space-3);\n}\n.rcti-designed .rcti-agreement-document__section h3 > span {\n  display: none;\n}\n.rcti-designed .rcti-agreement-document__section h3 {\n  margin-bottom: var(--space-3);\n}\n.rcti-public-topbar {\n  padding: var(--space-5) var(--space-8);\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-4);\n  background: var(--surface-primary);\n  border-bottom: 1px solid var(--border-subtle);\n}\n.rcti-public-topbar strong {\n  color: var(--interactive-default);\n}\n.rcti-public-topbar span {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-designed .rcti-public-workspace {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  grid-template-columns: minmax(0, 1.5fr) minmax(300px, 1fr);\n  display: grid;\n  gap: var(--space-6);\n  align-items: start;\n}\n.rcti-public-workspace > form,\n.rcti-public-workspace > .rcti-public-controls {\n  grid-column: 2;\n  grid-row: 1;\n  padding: var(--space-6);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  display: grid;\n  gap: var(--space-5);\n}\n.rcti-public-workspace > .rcti-agreement-document {\n  grid-column: 1;\n  grid-row: 1 / span 6;\n}\n.rcti-public-workspace > button {\n  grid-column: 2;\n}\n@media (max-width: 1000px) {\n  .rcti-design-columns {\n    grid-template-columns: minmax(0, 1.4fr) minmax(260px, 1fr);\n  }\n  .rcti-designed .rcti-agreement-document {\n    padding: var(--space-5);\n  }\n}\n@media (max-width: 760px) {\n  .rcti-agreements.rcti-designed .rcti-agreements__content {\n    padding: var(--space-5) var(--space-4);\n  }\n  .rcti-design-columns,\n  .rcti-designed .rcti-public-workspace {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-public-workspace > .rcti-agreement-document,\n  .rcti-public-workspace > form,\n  .rcti-public-workspace > button,\n  .rcti-public-workspace > .rcti-public-controls {\n    grid-column: 1;\n    grid-row: auto;\n  }\n  .rcti-design-metrics {\n    gap: var(--space-3);\n  }\n  .rcti-designed .rcti-design-metrics .rcti-agreement-card {\n    padding: var(--space-4);\n  }\n  .rcti-design-metrics span {\n    font-size: var(--font-size-caption-md);\n  }\n  .rcti-design-heading {\n    align-items: flex-start;\n    flex-wrap: wrap;\n  }\n  .rcti-design-heading h1 {\n    font-size: var(--font-size-h2);\n  }\n  .rcti-design-filter {\n    flex-wrap: wrap;\n  }\n  .rcti-journey {\n    gap: var(--space-3);\n  }\n  .rcti-journey li {\n    flex: 1;\n  }\n  .rcti-journey li::after {\n    display: none;\n  }\n  .rcti-journey-step {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-2);\n  }\n  .rcti-journey-step strong {\n    font-size: var(--font-size-caption-md);\n  }\n  .rcti-journey-step small {\n    display: none;\n  }\n  .rcti-public-topbar {\n    padding: var(--space-4);\n    flex-wrap: wrap;\n  }\n  .rcti-design-party-grid {\n    grid-template-columns: 1fr;\n  }\n  .rcti-design-footer {\n    position: sticky;\n    bottom: 0;\n    background: var(--bg-primary);\n    padding-bottom: var(--space-4);\n    z-index: 4;\n  }\n}\n@media print {\n  .rcti-public-topbar,\n  .rcti-journey,\n  .rcti-design-footer,\n  .rcti-public-workspace > form {\n    display: none !important;\n  }\n  .rcti-designed .rcti-public-workspace {\n    display: block;\n  }\n}\n/* Prepare, issue and detail use the same page rhythm as the PDF journeys. */\n.rcti-list-page,\n.rcti-editor-shell .invoice-editor-page,\n.rcti-detail-page {\n  max-width: 1440px;\n  margin-inline: auto;\n  padding: var(--space-8) var(--space-6);\n}\n.rcti-list-heading h1,\n.rcti-editor-shell .invoice-editor-header h1 {\n  font-size: var(--font-size-h1);\n  line-height: var(--line-height-h1);\n  font-weight: var(--font-weight-semibold);\n}\n.rcti-list-heading .rcti-header-actions {\n  margin-left: auto;\n}\n.rcti-header-actions a {\n  text-decoration: none;\n}\n.rcti-list-heading .rcti-design-breadcrumb {\n  margin-bottom: var(--space-3);\n}\n.rcti-financial-card {\n  border-radius: var(--radius-lg);\n  padding: var(--space-6);\n}\n.rcti-financial-card strong {\n  font-family: var(--font-family-mono);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-list-page .rcti-filters {\n  background: transparent;\n  border: 0;\n  padding: 0;\n}\n.rcti-list-page .rcti-list-filter-row {\n  padding: var(--space-4) 0;\n}\n.rcti-list-page .rcti-date-hint {\n  margin-top: 0;\n}\n.rcti-editor-shell .invoice-editor-grid {\n  grid-template-columns: minmax(0, 1fr);\n}\n.rcti-editor-shell .invoice-editor-column {\n  gap: var(--space-6);\n}\n.rcti-editor-shell .invoice-editor-aside {\n  position: static;\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-6);\n  align-items: start;\n}\n.rcti-editor-shell .invoice-flow-card,\n.rcti-detail-page .invoice-flow-card {\n  padding: var(--space-6);\n  border-radius: var(--radius-lg);\n}\n.rcti-editor-shell .invoice-total-card {\n  display: block;\n}\n.rcti-editor-shell .invoice-editor-aside > .invoice-document-actions {\n  grid-column: 1 / -1;\n}\n.rcti-editor-shell .invoice-item-table-head {\n  border-radius: var(--radius-md) var(--radius-md) 0 0;\n}\n.rcti-editor-shell .invoice-editor-intro {\n  font-size: var(--font-size-body-sm);\n  color: var(--text-secondary);\n}\n.rcti-detail-document .rcti-paper-parties {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  border-bottom: 1px solid var(--border-subtle);\n  padding-bottom: var(--space-5);\n}\n.rcti-detail-document .rcti-paper-heading {\n  min-height: 24px;\n  margin-bottom: var(--space-4);\n}\n.rcti-detail-document .rcti-paper-business .rcti-type-emphasis {\n  color: var(--interactive-default);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-detail-document .rcti-paper-identity h2 {\n  font-size: var(--font-size-h2);\n  font-weight: var(--font-weight-semibold);\n}\n.rcti-detail-document .rcti-paper-identity > span {\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-detail-document .rcti-detail-meta {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.rcti-detail-document .rcti-document-table-scroll {\n  border: 0;\n  border-radius: 0;\n}\n.rcti-detail-document .rcti-document-table th {\n  background: var(--surface-secondary);\n}\n.rcti-detail-document .rcti-detail-summary .grand {\n  background: transparent;\n  padding-inline: 0;\n  border-top: 1px solid var(--border-default);\n  border-radius: 0;\n}\n.rcti-detail-page .rcti-detail-context {\n  background: var(--success-soft);\n  border-color: var(--success-border);\n}\n.rcti-detail-page .rcti-detail-context .rcti-type-emphasis {\n  color: var(--success-text);\n}\n.rcti-review-workspace.rcti-communication-backdrop {\n  padding: 0;\n  background: var(--bg-primary);\n  align-items: stretch;\n  z-index: 1300;\n}\n.rcti-review-workspace .rcti-communication-dialog {\n  max-width: none;\n  width: 100%;\n  max-height: 100dvh;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  background: var(--bg-primary);\n  padding: var(--space-6) max(var(--space-6), calc((100vw - 1300px) / 2));\n  overflow-y: auto;\n}\n.rcti-review-workspace .rcti-communication-header {\n  padding: 0 0 var(--space-5);\n  border: 0;\n  background: transparent;\n}\n.rcti-review-workspace .rcti-communication-header h2 {\n  font-size: var(--font-size-h1);\n}\n.rcti-review-workspace .rcti-review-columns,\n.rcti-review-eligibility {\n  display: grid;\n  grid-template-columns: minmax(0, 1.55fr) minmax(300px, 1fr);\n  align-items: start;\n  gap: var(--space-6);\n}\n.rcti-review-workspace .rcti-review-columns > form,\n.rcti-review-workspace .rcti-agreement-card {\n  display: grid;\n  gap: var(--space-5);\n  min-width: 0;\n  padding: var(--space-6);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n}\n.rcti-review-document {\n  min-width: 0;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background: var(--surface-primary);\n}\n.rcti-review-document-bar {\n  padding: var(--space-4);\n  background: var(--surface-secondary);\n  display: flex;\n  justify-content: space-between;\n  gap: var(--space-3);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-workspace .rcti-detail-document {\n  padding: var(--space-6);\n  border: 0;\n  border-radius: 0;\n  margin: 0;\n}\n.rcti-review-workspace .rcti-detail-document .rcti-document-table {\n  min-width: 580px;\n}\n.rcti-review-workspace .rcti-communication-field {\n  margin: 0;\n}\n.rcti-review-workspace .rcti-communication-context {\n  margin: 0;\n}\n.rcti-review-workspace .rcti-communication-actions {\n  padding: var(--space-4) 0 0;\n  margin: 0;\n  background: transparent;\n}\n.rcti-review-workspace .rcti-communication-actions .primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n}\n.rcti-review-issue-info {\n  display: grid;\n  gap: var(--space-4);\n  border-top: 1px solid var(--border-default);\n  padding-top: var(--space-5);\n}\n.rcti-review-issue-info p,\n.rcti-review-issue-info label {\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-review-checks {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.rcti-review-checks li {\n  padding: var(--space-5) 0;\n  border-bottom: 1px solid var(--border-subtle);\n}\n.rcti-review-checks li:last-child {\n  border: 0;\n}\n.rcti-review-checks strong {\n  font-size: var(--font-size-body-md);\n}\n.rcti-review-checks p {\n  margin-top: var(--space-3);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-review-workspace button {\n  cursor: pointer;\n}\n.rcti-review-workspace .rcti-communication-success {\n  max-width: 680px;\n  margin: var(--space-8) auto;\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-lg);\n}\n@media (max-width: 760px) {\n  .rcti-list-page,\n  .rcti-editor-shell .invoice-editor-page,\n  .rcti-detail-page {\n    padding: var(--space-5) var(--space-4);\n  }\n  .rcti-editor-shell .invoice-editor-aside,\n  .rcti-review-workspace .rcti-review-columns,\n  .rcti-review-eligibility {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-review-workspace .rcti-communication-dialog {\n    padding: var(--space-5) var(--space-4);\n  }\n  .rcti-review-workspace .rcti-communication-header h2 {\n    font-size: var(--font-size-h2);\n  }\n  .rcti-detail-document .rcti-paper-parties {\n    grid-template-columns: 1fr;\n  }\n  .rcti-list-heading .rcti-header-actions {\n    margin-left: 0;\n  }\n}\n.rcti-agreements.rcti-designed .rcti-design-metrics > button {\n  width: 100%;\n  min-height: 154px;\n  align-content: start;\n}\n.rcti-designed .rcti-design-metrics > button > span {\n  font-size: var(--font-size-body-md);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-designed .rcti-design-register td:first-child > button {\n  font-family: var(--font-family-mono);\n  white-space: nowrap;\n}\n.rcti-designed .rcti-design-register .rcti-agreement-badge {\n  white-space: nowrap;\n}\n.rcti-agreements__content .rcti-design-heading > button,\n.rcti-agreements__content .rcti-design-footer > button:last-child {\n  color: var(--on-interactive-primary);\n}\n.rcti-editor-shell .invoice-editor-header {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  align-items: start;\n}\n.rcti-editor-shell .invoice-editor-header > small {\n  grid-column: 1 / -1;\n}\n.rcti-editor-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-4);\n  border-top: 1px solid var(--border-default);\n  margin-top: var(--space-6);\n  padding-top: var(--space-5);\n}\n.rcti-editor-footer > div {\n  display: flex;\n  gap: var(--space-3);\n}\n.rcti-editor-footer button {\n  display: inline-flex;\n  height: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md, 10px);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: normal 500 13px/normal var(--font-family-primary, \"Lexend\", sans-serif);\n  cursor: pointer;\n}\n.rcti-editor-footer button.primary {\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border-color: var(--interactive-default);\n}\n.rcti-editor-footer button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.rcti-editor-agreement-strip {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-5);\n  margin: var(--space-4) 0;\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  background: var(--surface-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-editor-agreement-strip > div {\n  display: grid;\n  gap: var(--space-2);\n  justify-items: start;\n}\n.rcti-editor-agreement-strip a {\n  color: var(--interactive-default);\n}\n@media (max-width: 760px) {\n  .rcti-editor-shell .invoice-editor-header {\n    grid-template-columns: 1fr;\n  }\n  .rcti-editor-footer {\n    flex-wrap: wrap;\n  }\n  .rcti-editor-footer > div {\n    flex-wrap: wrap;\n  }\n  .rcti-editor-agreement-strip {\n    grid-template-columns: 1fr;\n  }\n}\n.rcti-editor-shell .invoice-editor-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 360px;\n  align-items: start;\n  gap: var(--space-6);\n}\n.rcti-editor-shell .invoice-editor-column {\n  display: flex;\n  min-width: 0;\n}\n.rcti-editor-shell .invoice-editor-aside {\n  grid-column: 2;\n  grid-row: 1;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n  position: sticky;\n  top: 88px;\n  max-height: calc(100vh - 112px);\n  overflow-y: auto;\n  min-width: 0;\n}\n.rcti-editor-shell .invoice-editor-aside > * {\n  width: 100%;\n  min-width: 0;\n  flex-shrink: 0;\n}\n.rcti-editor-shell .invoice-summary-card {\n  order: 0;\n}\n.rcti-editor-shell .rcti-editor-notes .invoice-notes-fields {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n.rcti-editor-shell .rcti-editor-notes textarea {\n  min-height: 88px;\n}\n.rcti-editor-shell .rcti-editor-notes h3 {\n  font-size: var(--font-size-body-sm);\n  margin: var(--space-5) 0 var(--space-3);\n}\n.rcti-editor-settlement h2 {\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n  margin: 0 0 var(--space-5);\n}\n@media (min-width: 701px) {\n  .rcti-editor-shell .invoice-date-fields {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n  .rcti-editor-shell .invoice-item-heading,\n  .rcti-editor-shell .invoice-edit-item {\n    grid-template-columns: minmax(0, 1fr) 48px 96px 84px 104px 32px;\n  }\n  .rcti-editor-shell .invoice-edit-item .discount-type {\n    width: 100%;\n    max-width: 148px;\n  }\n}\n@media (max-width: 1279px) {\n  .rcti-editor-shell .invoice-editor-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .rcti-editor-shell .invoice-editor-aside {\n    grid-column: 1;\n    grid-row: auto;\n    position: static;\n    max-height: none;\n    overflow-y: visible;\n  }\n  .rcti-editor-shell .rcti-editor-notes .invoice-notes-fields {\n    grid-template-columns: 1fr;\n  }\n}\n/* Override the shared launcher's !important mobile display: AppHeader already\n   supplies this menu, and the duplicate must not cover footer actions. */\n.rcti-designed .dashboard-sidebar-launcher,\n.rcti-editor-shell .dashboard-sidebar-launcher,\n.rcti-detail-shell .dashboard-sidebar-launcher,\n.rcti-flow-shell .dashboard-sidebar-launcher {\n  display: none !important;\n}\n/* Shared themed dropdowns must override agreement-wide button styling. */\n.rcti-agreements__content .quotation-figma-dropdown { width: 100%; min-width: 0; }\n.rcti-agreements__content .quotation-figma-dropdown-trigger,\n.rcti-flow-shell .rcti-filter-select .quotation-figma-dropdown-trigger,\n.rcti-payment-dialog .quotation-figma-dropdown-trigger {\n  display: flex; align-items: center; justify-content: space-between;\n  width: 100%; min-height: 40px; height: 40px; padding: 0 var(--space-3);\n  border: 1px solid var(--border-default); border-radius: var(--radius-md);\n  background: var(--surface-primary); color: var(--text-primary);\n  font: inherit; font-size: var(--font-size-body-sm); text-align: left;\n}\n.rcti-agreements__content .quotation-figma-dropdown-trigger:hover:not(:disabled) { background: var(--surface-secondary); }\n.rcti-agreements__content .quotation-figma-dropdown-option {\n  width: 100%; min-height: 36px; padding: var(--space-2) var(--space-3);\n  border: 0; border-radius: var(--radius-sm); background: transparent;\n  color: var(--text-primary); font-size: var(--font-size-body-sm); text-align: left;\n}\n.rcti-agreements__content .quotation-figma-dropdown-option:hover:not(:disabled),\n.rcti-agreements__content .quotation-figma-dropdown-option.is-selected {\n  background: var(--interactive-soft); color: var(--interactive-default);\n}\n.rcti-flow-shell .rcti-filter-select { padding: 0; border: 0; background: transparent; }\n.rcti-filter-select .quotation-figma-dropdown { width: 100%; min-width: 180px; }\n.rcti-flow-shell .rcti-filter-select { flex: 0 1 200px; width: 200px; min-width: 0; }\n.rcti-flow-shell .rcti-due-select { flex-basis: 240px; width: 240px; }\n.rcti-filter-select .quotation-figma-dropdown { min-width: 0; }\n.rcti-filter-select .quotation-figma-dropdown svg { position: static; right: auto; pointer-events: none; }\n.rcti-agreements__content .quotation-figma-dropdown-trigger > svg,\n.rcti-filter-select .quotation-figma-dropdown-trigger > svg,\n.rcti-payment-dialog .quotation-figma-dropdown-trigger > svg {\n  display: block; position: static; flex: 0 0 20px; width: 20px; height: 20px;\n  overflow: visible; color: var(--text-secondary);\n}\n@media (max-width: 760px) {\n .rcti-flow-shell .rcti-filter-select, .rcti-flow-shell .rcti-due-select { flex: 1 1 160px; width: auto; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
